<template>
  <section>
    <v-row>
      <v-col class="px-6" cols="12" :md="subscription && subscription.paypal_plan ? 6 : 12">
        <div style="position:relative">
          <v-btn
            absolute
            right
            fab
            dark
            x-small
            color="grey darken-3"
            class="mt-4"
            title="Populate with my details"
            @click="populate()"
          >
            <v-icon>mdi-account-edit-outline</v-icon>
          </v-btn>
          <v-form ref="form" v-model="valid" @submit.prevent="saveAccount" lazy-validation>
            <v-card :loading="saving">
              <v-card-title>
                <span class="text-h4">
                  Account
                  <span class="pl-3 subtitle-1">Details</span>
                </span>
              </v-card-title>
              <v-card-text>
                <v-alert dense type="warning" v-if="errors.server">{{errors.server}}</v-alert>
                <v-container v-if="account">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        label="Name*"
                        hint="Billing to name"
                        v-model="account.name"
                        :rules="nameRules"
                        validate-on-blur
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6"></v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        label="Email*"
                        v-model="account.email"
                        :rules="emailRules"
                        :error-messages="errors.email"
                        validate-on-blur
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field label="Phone" v-model="account.phone"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        :auto-grow="true"
                        :no-resize="true"
                        :rows="5"
                        label="Address"
                        v-model="account.address"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        :auto-grow="true"
                        :no-resize="true"
                        :rows="5"
                        label="Postal Address"
                        v-model="account.postal"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field label="VAT" v-model="account.vat"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
                <small>*indicates required field</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" outlined type="submit">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </div>
      </v-col>
      <v-col class="px-6" cols="12" md="6" v-if="subscription && subscription.paypal_plan">
        <v-card>
          <v-card-title>
            <span class="text-h4">
              Subscription
              <!--<span class="pl-3 subtitle-1">Information</span>-->
            </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <Subscription></Subscription>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { makeGetMixin } from "feathers-vuex";
import { models } from "feathers-vuex";
import Subscription from "@/components/config/subscription/Subscription";

export default {
  data: () => ({
    account: {},
    saving: false,
    valid: false,
    errors: {
      email: "",
      server: "",
    },
    nameRules: [
      (v) => !!v || "First and last name is required",
      (v) => (v && v.length >= 3) || "Cannot be less than 3 characters",
    ],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
  }),
  mixins: [
    makeGetMixin({ service: "subscription", id: "subscriptionID" }),
  ],
  created() {
    const { Account } = models.api;
    Account.on("created", () => {});
  },
  async mounted() {},
  destroyed() {
    const { Account } = models.api;
    Account.off("created", () => {});
  },
  computed: {
    ...mapGetters("apiAuth", ["user"]),
    subscriptionID() {
      return (
        this.user &&
        this.user.account &&
        this.user.account.subscription &&
        this.user.account.subscription.id
      );
    },
  },
  methods: {
    ...mapActions("app", ["showMessage"]),
    ...mapActions("users", { getUser: "get" }),
    validate() {
      return this.$refs.form.validate();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
      this.errors.server = "";
    },
    populate() {
      this.account.name = `${this.user.first_name} ${this.user.last_name}`;
      this.account.email = this.user.email;
      this.account.phone = this.user.cell;
    },
    async loadAccount() {
      try {
        const { Account } = models.api;
        const account = this.user.account_id
          ? await Account.get(this.user.account_id)
          : null;
        this.account = account ? account : new Account();
      } catch (error) {
        console.log('Account forbidden...')
      }
    },
    async saveAccount() {
      if (!this.validate()) return;

      try {
        this.saving = true;
        await this.account.save();
        //await this.getUser(this.user.id);
        this.saving = false;
        this.showMessage({ text: "Account saved!", color: "green" });
      } catch (error) {
        this.saving = false;
        this.valid = false;

        if (error.message.includes("accounts_email_unique")) {
          this.errors.email = "Email already exists for another account.";
        } else {
          this.errors.server = error.message;
        }
      }
    },
  },
  watch: {
    account: {
      handler() {
        if (!this.valid) {
          this.resetValidation();
        }
      },
      deep: true,
    },
    user: {
      handler(user) {
        if (user) this.loadAccount();
      },
      immediate: true,
    },
  },
  components: {
    Subscription,
  },
};
</script>